var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPurpulePhone = function SvgPurpulePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#9083E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.167 12.106.861-.861a.843.843 0 0 1 .9-.185l1.05.42a.838.838 0 0 1 .522.768v1.922a.835.835 0 0 1-.877.827c-7.353-.458-8.837-6.685-9.118-9.069a.834.834 0 0 1 .834-.926h1.857a.83.83 0 0 1 .769.523l.419 1.05a.83.83 0 0 1-.18.899l-.862.86s.496 3.357 3.825 3.772Z",
    fill: "#fff"
  })));
};
export default SvgPurpulePhone;